import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import AppRoutePath from "../../../router/AppRoutePath";
import httpclient from "../../../components/httpclient";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import RegulerInformationArea from "../helpers/regularInformation";
import { Button } from "react-bootstrap";
import TextInput from "../components/TextInput"
import { FaPlus, FaBan, FaTrashAlt } from "react-icons/fa";
import CustomNumberFormat from "../components/CustomNumberFormat";
import IsEmpty from "../../../components/helpers/IsEmpty";
import styled from "styled-components"
export default function AddArea() {
  const location = useRouteMatch();
  const history = useHistory();
  const [id, setId] = useState();
  const [totalRecords, setTotalRecords] = useState();
  const [loading, setLoading] = useState(false);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [area, setArea] = useState();
  const [inputKota, setInputKota] = useState([
    {
      name: "",
      product_category_ids: [],
      subdistricts:
        [
          {
            name: "",
            fee_shipping_above_kg: null,
            fee_shipping_below_kg: null
          }
        ]
    }
  ]);
  const [errorArea, setErrorArea] = useState();
  const [errorCity, setErrorCity] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorBelowKg, setErrorBelowKg] = useState();
  const [errorSub, setErrorSub] = useState();
  const [nameCity, setNameCity] = useState();
  const [productList, setProductList] = useState([]);
  const [nameSub, setNameSub] = useState();
  const [belowKg, setBelowKg] = useState();


  useEffect(() => {
    getCategory();
  }, []);


  useEffect(() => {
    if (productCategoryList.length < 1) {
      return
    }
    getData(location.params.id);
  }, [productCategoryList]);

  const getData = (id) => {
    if (!location.params.id) {
      return
    } else {

      let url = `${process.env.REACT_APP_BASE_API_URL}area/${id}`;

      AxiosCustomGet(
        url,
        Config(
          {
            Authorization: `Bearer ${Cookies.get("access_token")}`,
          },
        ),
        (response) => {


          let data = response.data.data;

          let kota = data.cities;

          for (let x of kota) {
            x.product_category_ids = []
            for (let i of x.city_product_categories) {
              x.product_category_ids.push(productCategoryList.find((obj) => obj.value === i.product_category_id))
              // = productCategoryList.filter((obj) => i.product_category_id.includes(obj.value))
            }
          }


          // console.log([...data.cities])
          setId(data.id)
          setArea(data.name)
          setInputKota(kota)

          // console.log(inputKota.)

          let list = [...data.cities]
          list.map((item) => {
            item.city_product_categories.map((i) => {
              // setInputKota.product_category_ids.push(i.product_category_id)
              // console.log(i)
            })
          })
          // setSelectedCategory(category)

          setTotalRecords(data.total_item);
          setLoading(false);
          setTablePagination({
            current: response.data.data?.page,
            pageSize: response.data.data?.per_page,
            total: response.data.data?.total_item,
          });
        },
        (error) => {
          console.log(error);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }

  };



  const handleinputKota = (e) => {
    const { value } = e.target;
    setArea(value)
  }



  const handleInputSub = (name, value, indexSub, indexCity) => {

    const list = [...inputKota];
    list[indexCity].subdistricts[indexSub][name] = value;

    setInputKota(list);

    if (name == "name") {
      setNameSub(value)
    } if (name == "fee_shipping_below_kg") {
      setBelowKg(value)
    }
  }

  const handleDelCity = (indexCity) => {
    const list = [...inputKota];
    // const lastIndex = list.length - 1;
    list.splice(indexCity, 1);

    setInputKota(list)
  }


  const handleInputCity = (name, value, indexCity) => {
    const list = [...inputKota];

    list[indexCity][name] = value;

    setInputKota(list)

    if (name == "name") {
      setNameCity(value)
    }
    if (name == "product_category_ids") {
      setProductList(value)
    }
  }

  const hanleAddSubdistrict = (e, indexCity) => {
    const list = [...inputKota];

    list[indexCity].subdistricts.push({
      name: "",
      fee_shipping_above_kg: null,
      fee_shipping_below_kg: null
    })

    setInputKota(list)
  }

  const handleAddCity = (e) => {
    e.preventDefault()
    const list = [...inputKota];

    list.push({
      name: "",
      product_category_ids: [],
      subdistricts:
        [
          {
            name: "",
            fee_shipping_above_kg: 0,
            fee_shipping_below_kg: 0
          }
        ]
    })

    setInputKota(list)
  }

  const hanleDelSubdistrict = (e, indexSub, indexCity) => {
    const list = [...inputKota];
    // const lastIndex = list[indexCity].subdistricts.length - 1;

    list[indexCity].subdistricts.splice(indexSub, 1);
    setInputKota(list)

  }

  const handleSubmit = () => {

    if (!location.params.id) {
      if (!validate()) return;
      setSubmitting(true);
      let data = {
        id: id,
        name: area,
        cities: inputKota.map((item) => (
          {
            ...item,
            product_category_ids: item.product_category_ids.map((item) => (
              item.value
            ))
          }
        ))
      }

      let url = `${process.env.REACT_APP_BASE_API_URL}area`;
      httpclient
        .POST(url, data)
        .then((response) => {
          history.push(AppRoutePath.AREA_LIST);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });

          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {

      setSubmitting(true);
      let data = {
        id: id,
        name: area,
        cities: inputKota.map((item) => (
          {
            ...item,
            product_category_ids: item.product_category_ids.map((item) => (
              item.value
            ))
          }
        ))
      }

      let url = `${process.env.REACT_APP_BASE_API_URL}area`;
      httpclient
        .POST(url, data)
        .then((response) => {
          history.push(AppRoutePath.AREA_LIST);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });

          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }



  };

  const getCategory = () => {

    setLoading(true);

    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setProductCategoryList(
          response.data.data.items.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };


  const handleSelectChange = (data, indexCity) => {

    const list = [...inputKota]
    list[indexCity].product_category_ids = data
    setInputKota(list);

    // setSelectedCategory(Array.isArray(data) ? data.map((x) => x.value) : []);


  }


  const validate = () => {
    setErrorArea()
    setErrorCity()
    setErrorCategory([])
    setErrorBelowKg()
    setErrorSub()
    let validate = true;

    if (IsEmpty(area)) {
      validate = false;
      setErrorArea("Data Provinsi Harus Di Isi !")
    } if (IsEmpty(nameCity)) {
      validate = false;
      setErrorCity("Data Kota/Kabupaten Harus Di Isi !");
    } if (productList.length === 0) {
      validate = false;
      setErrorCategory("Data Kategori Harus Di pilih !")
    } if (IsEmpty(belowKg)) {
      validate = false;
      setErrorBelowKg("Data Ongkir Belum Di Isi !")
    } if (IsEmpty(nameSub)) {
      validate = false;
      setErrorSub("Data Kecamatan Belum Di Isi !")
    }
    console.log(validate)
    return validate
  }


  return (
    <div>
      <div className="p-3">
        {/* <form onSubmit={() => this.submit}> */}
        <div className="mb-3">
          <h5 className="font-weight-bold">{(!location.params.id) ? "Tambah Area Jemput Gadai" : "Ubah Area Jemput Gadai"} </h5>
          {/* <Title text="Area Jemput Gadai" /> */}
          <Breadcrumb current="Area Jemput Gadai" />
        </div>
        <div className="container-campaign">
          <div className="container-input-1">


            <div className="container-input my-3">
              <div className="container-sk">
                <div className="label-campaign" style={{ marginTop: -10 }}>Provinsi</div>
                <TextInput
                  label="Nama Provinsi"
                  name="name"
                  value={area}
                  onChange={(e) => handleinputKota(e)}
                />
                <p className="text-danger mt-2">{errorArea}</p>
              </div>
            </div>

            {inputKota.map((city, indexCity) => (
              <div className="container-input my-3">
                <div className="row">
                  <div className="col-11">
                    <div className="label-campaign">Kota/Kabupaten {indexCity + 1}</div>
                  </div>
                  {inputKota.length > 1 &&
                    <div className="col-1">
                      <FaTrashAlt style={{ fontSize: 20, cursor: "pointer" }} className="text-danger mr-2" onClick={() => handleDelCity(indexCity)} />
                    </div>
                  }
                </div>
                <div className="container-sk d-flex">
                  <div className="col-6 px-0">
                    <TextInput
                      label="Nama Kota/Kabupaten"
                      onChange={(e) => handleInputCity(e.target.name, e.target.value, indexCity)}
                      name="name"
                      value={city.name}
                    />
                    <p className="text-danger mt-2">{errorCity}</p>
                  </div>
                  <div className="col-6 pr-0">
                    <label>
                      Kategori Barang
                    </label>
                    <Select
                      name="product_category_ids"
                      onChange={(data) => handleInputCity("product_category_ids", data, indexCity)}
                      isMulti
                      options={productCategoryList}
                      value={city.product_category_ids}
                    >
                    </Select>
                    <p className="text-danger mt-2">{errorCategory}</p>
                  </div>
                </div>
                {city.subdistricts.map((subdistrict, indexSub) =>
                (
                  <div className="container-sk">
                    <div className="row">
                      <div className="col-6 pr-0">
                        <TextInput
                          label="Kecamatan"
                          name="name"
                          value={subdistrict.name}
                          onChange={(e) => {
                            handleInputSub(e.target.name, e.target.value, indexSub, indexCity)
                          }}
                        />
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-5 pr-0">
                            <CustomNumberFormat
                              value={subdistrict.fee_shipping_below_kg}
                              label="Ongkir &#40; &lt; 5kg &#41;"
                              isNumericString={true}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              onValueChange={({ floatValue }) => handleInputSub("fee_shipping_below_kg", floatValue, indexSub, indexCity)}
                            />
                            <p className="text-danger mt-2" style={{ fontSize: 12 }}>{errorBelowKg}</p>
                          </div>
                          <div className="col-5 pr-0">
                            <CustomNumberFormat
                              value={subdistrict.fee_shipping_above_kg}
                              label="Ongkir &#40; &gt; 5kg &#41;"
                              isNumericString={true}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              onValueChange={({ floatValue }) => handleInputSub("fee_shipping_above_kg", floatValue, indexSub, indexCity)}
                              name="fee_shipping_above_kg"
                            />
                            <p className="text-danger mt-2" style={{ fontSize: 12 }}>{errorBelowKg}</p>
                          </div>
                          {city.subdistricts.length > 1 &&
                            <div className="col-1 pr-0 align-self-center">
                              <FaTrashAlt style={{ fontSize: 20, cursor: "pointer" }} className="text-danger" onClick={(e) => hanleDelSubdistrict(e, indexSub, indexCity)} />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="d-flex">
                  <div
                    onClick={(e) => hanleAddSubdistrict(e, indexCity)}
                    style={{ color: "#2C465C", cursor: "pointer", marginTop: 20, fontSize: 14, fontWeight: "400", width: 160, marginRight: 20 }}>
                    <FaPlus className="mr-2" />
                    Tambah Kecamatan
                  </div>
                </div>
              </div>
            ))}
            <div className="d-flex">
              <div
                onClick={handleAddCity}
                className="d-flex align-items-center"
                style={{ color: "#2C465C", cursor: "pointer", marginTop: 20, fontSize: 14, fontWeight: "400", width: 300 }}>
                <FaPlus className="mr-2" style={{ marginLeft: 12 }} />
                Tambah Kota/Kabupaten
              </div>
            </div>
            <div className="ml-auto d-flex align-items-center justify-content-end">
              <Link to={AppRoutePath.AREA_LIST}>
                <Button
                  className="btn-action"
                  style={{
                    width: 120,
                    height: 36,
                    margin: 5,
                    background: "#fff",
                    border: "0.75px solid #DCDCDC",
                    color: "#2C465C",
                  }}
                >
                  Kembali
                </Button>
              </Link>
              <Button
                id={!location.params.id ? "tambah" : "ubah"}
                onClick={(id) => handleSubmit(id.target.id)}
                variant="primary"
                className="btn-action btn-add"
                style={{ width: 120, height: 36, margin: 5 }}
              >
                {!location.params.id ? "Tambah" : "Ubah"}
              </Button>
            </div>
          </div>

          <RegulerInformationArea />
        </div>
      </div >
    </div >


  );

}


const IconDel = styled.div`
  font-size:22px
`